<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Заказы ресторанов</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <OrdersTable :list.sync="items" order-type="rd" />
                        <CPagination
                            :active-page.sync="activePage"
                            class="mt-4"
                            :pages="total"
                            align="center"
                        />
                    </template>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import OrdersTable from '@/components/orders/OrdersTable';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {

        name: 'OrdersRD',

        components: {
            OrdersTable,
        },

        data() {
            return {
                loading: true,
                items: [],
                total: 1,
                timerId: null,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
        },

        async mounted() {
            await this.loadData();
            this.loading = false;
            this.timerId = setInterval(this.loadData, 10000);
        },

        beforeDestroy() {
            clearInterval(this.timerId);
        },

        methods: {
            async loadData() {
                const params = { page: this.activePage, pageSize: ITEMS_PER_PAGE };
                await Vue.axios
                    .get('/orders-rd', { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                    });
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
